const sessionCouldHaveTaggingData = function(sessionContentsOrVersion, schemaRef) {
    return true;
};

export default sessionCouldHaveTaggingData;